import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";
import {ActiveEventIds} from "../../utils/searchFixtures";

export const getActiveEventIds = (state: ReducerFromState<ExtraReducer>): ActiveEventIds =>
    state.extra.activeEventIds;
